import { useTranslation } from 'react-i18next'

import { ActionModal, Flex, Modal } from '@percent/lemonade'
import { ShowNotesModalProps } from './ShowNotesModal.types'

export function ShowNotesModal({ isOpen, setIsOpen, notes }: Readonly<ShowNotesModalProps>) {
  const { t } = useTranslation()

  const closeModal = () => {
    setIsOpen(false)
  }

  return (
    <Modal open={isOpen} onClose={closeModal}>
      <ActionModal
        title={t('dialog.notes.title')}
        primaryButtonText={t('button.close')}
        primaryBtnTestId="show-notes"
        handleClose={closeModal}
        handleSubmit={closeModal}
      >
        <Flex direction="column" gap={8}>
          <div style={{ maxHeight: '60vh', overflowY: 'auto' }}>{notes}</div>
        </Flex>
      </ActionModal>
    </Modal>
  )
}
